var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"report p-3"},[_c('joint-report-cover-page',{attrs:{"noOfPages":_vm.noOfPages,"reportRows":_vm.reportRows}}),_vm._v(" "),_vm._l((_vm.noOfPages),function(n){return _c('joint-report-page',{key:n,attrs:{"pageNo":n,"noOfPages":_vm.noOfPages,"reportRows":_vm.pageSlice(_vm.reportRows, n)}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07a099a5","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/JointReport.vue
// module id = 1370
// module chunks = 86